<template>
  <div class="projectList">
    <div class="top">
      <div class="top__large">项目展示</div>
      <div class="top__small">Achievements</div>
    </div>
    <div class="contentBox">
      <ul class="achievements">
        <li v-for="(item,index) in acheList" :key="index">
          <div class="title" :id="item.key">{{item.class}}<span @click="more(item.key)" class="more">了解更多<Icon type="md-arrow-forward" /></span></div>
            <Carousel dots='inside' :autoplay="autoplay[index]" arrow='hover' :autoplay-speed=4000 :radius-dot="true" class="Carousel">
              <CarouselItem v-for="(image,num) in item.images" :key="num">
                <img :src="image" >
              </CarouselItem>
            </Carousel>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'projectList',
  data () {
    return {
      acheList: [
        {
          class: '工程结构仿真',
          key: 'ana',
          images: [
            'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/ache_ana1.jpg',
            'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/ache_ana2.jpg',
            'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/ache_ana3.jpg',
            'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/ache_ana4.jpg',
            'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/ache_ana5.jpg',
            'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/ache_ana6.jpg',
            'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/ache_ana7.jpg',
          ]
        },
        {
          class: '工程智能监测',
          key: 'moni',
          images: [
            'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/ache_moni1.jpg',
            'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/ache_moni2.jpg',
            'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/ache_moni3.jpg',
            'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/ache_moni4.jpg',
            'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/ache_moni5.jpg',
            'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/ache_moni6.jpg',
            'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/ache_moni7.jpg',
            'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/ache_moni8.jpg',
            'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/ache_moni9.jpg',
            'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/ache_moni10.jpg',
            'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/ache_moni11.jpg',
            'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/ache_moni12.jpg',
          ]
        },
        {
          class: '工程数字科技',
          key: 'tech',
          images: [
            'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/ache_tech1.jpg',
            'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/ache_tech2.jpg',
          ]
        },
        // {
        //   class: '工程结构研发',
        //   key: 'dev',
        //   images: [
        //     'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/ache_dev1.jpg',
        //   ]
        // }
      ],
      autoplay: [true, true, true, true],
    }
  },
  created() {
    this.$emit('changeProduce','projectList')
  },
  mounted() {
    if(this.$route.params.scroll){
      let position = document.querySelector('#'+this.$route.params.scroll).offsetTop
      window.scrollTo({top: position, left: 0, behavior: "smooth" })
      this.$route.params.scroll = null
    }
    let carousels = document.getElementsByClassName('Carousel')
    const _this = this
    carousels.forEach((item, index) => {
      item.onmouseover = function() {
        _this.$set(_this.autoplay,index,false)
      }
      item.onmouseout = function() {
        _this.$set(_this.autoplay,index,true)
      }
    });
  },
  methods: {
    more(id){
      this.$router.push({name:'projectList_detail',params: {id: id}})
    }
  }
}
</script>

<style lang="less" scoped>
.projectList {
  .top {
    width: 100%;
    height: 280px;
    background: url("https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/ache_banner.png")
      center center no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    font-weight: bold;
    color: #fff;
    // padding-left: 210px;
    &__large {
      font-size: 40px;
      line-height: 1.5em;
      margin-left: 210px;
    }
    &__small {
      font-size: 24px;
      line-height: 1.2em;
      margin-left: 210px;
    }
  }

  .contentBox {
    .achievements{
      display: flex;
      flex-direction: column;
      width: 100%;
      padding: 20px 0;
      li{
        display: flex;
        flex-direction: column;
        width: 98%;
        margin: 30px auto;
        justify-content: center;
        align-items: center;
        .title {
          display: block;
          width: 280px;
          margin: 48px auto 40px;
          position: relative;
          font-size: 24px;
          line-height: 1.5em;
          font-weight: bold;
          color: #000;
          text-align: center;

          .more{
            display: block;
            width: max-content;
            cursor: pointer;
            position: absolute;
            top: 0;
            left: 220px;//7em
            font-size: 18px;
            color: #FAAD14;
          }
        }
        .title::after {
          content: "";
          position: absolute;
          bottom: -8px;
          left: 50%;
          transform: translateX(-50%);
          width: 50px;
          height: 8px;
          background-color: #FAAD14;
        }
        .Carousel{
          margin: 0 auto;
          width: 98%;
        }
        img{
          margin: 10px auto;
          display: block;
          width: 75%;
        }
      }
    }
  }
}
</style>
